import type { FaireAdvertiserProfileEntity } from "../../entity_types/advertiserProfile";

// PennyLine (b_kttkmvdusx, advertiser 2068317978580945711).
// Lifetime complete-month metrics through Aug 2026.
export const advPennyline: FaireAdvertiserProfileEntity = {
  token: "adv_pennyline",
  type: "advertiserProfile",
  archetype: "budget-capped",
  displayName: "PennyLine",
  brandToken: "b_kttkmvdusx",
  audienceType: "NEW_AND_RETURNING",
  globalStatus: "ACTIVE",
  tenureMonths: 24,
  budget: {
    totalBudgetDollars: 1000,
    sharedBudgetDollars: 1000,
    spendingMode: "MAXIMUM",
    nextRenewsAtDate: "2026-10-01",
    nextBillsAtDate: "2026-10-04",
  },
  overview: {
    numCustomersAcquired: 192,
    numReorderConversions: 126,
    numTotalConversions: 318,
    totalAdsSalesDollars: 143678,
    newCustomerAdsSalesDollars: 111625,
    reorderAdsSalesDollars: 32053,
    totalAdsSpendDollars: 12828,
    newCustomerAdsSpendDollars: 10040,
    reorderAdsSpendDollars: 2788,
    newCustomerBestEstimateFirstYearRoas: 11.58,
    reorderRoas: 11.5,
    combinedFirstYearRoas: 11.56,
    numNewCustomerAdsOrders: 400,
    numReorderAdsOrders: 126,
  },
  availableCredit: { totalRemainingDollars: 0 },
  budgetRecommendations: {
    newCustomer: {
      minRecommendedBudgetDollars: 780,
      maxRecommendedBudgetDollars: 1560,
      isEligibleForIncreaseRec: false,
    },
    reorder: {
      minRecommendedBudgetDollars: 240,
      maxRecommendedBudgetDollars: 480,
      isEligibleForIncreaseRec: false,
    },
  },
  campaignTokens: ["camp_pl_new", "camp_pl_reorder"],
  overviewPerformancePeriodTokens: [],
  meta: {
    source: "snowflake",
    importedAt: "2026-09-25T00:00:00.000Z",
    importedBy: "real-brand-data",
  },
};
